<nav class="nav-bar">
    <div class="nav-item" routerLink="/pages/get-addons" routerLinkActive="active">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsConsultUsers.png" alt="User consultation icon" />
        </div>
        <span class="nav-label">Consulta de usuarios</span>
        <div class="nav-divider-horizontal"></div>
      </div>

    </div>
    <div class="nav-item" routerLink="/pages/get-user" routerLinkActive="active">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsRoles.png" alt="Rols icon" />
        </div>
        <span class="nav-label">Roles</span>
        <div class="nav-divider-horizontal"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/unblock-user" routerLinkActive="active">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsUnlock.png" alt="Unlock icon" />
        </div>
        <span class="nav-label nav-label-margin">Desbloquear</span>
        <div class="nav-divider-horizontal"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/update-contact" routerLinkActive="active">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconUpdateUser.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Actualizar contacto</span>
        <div class="nav-divider-horizontal"></div>
      </div>
    </div>
  </nav>